import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoMapMixin from './KendoMapMixin'

export default {
    name: 'kendo-map',
    mixins: [ KendoMapMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('div', defaultSlot)
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-map-vue-wrapper/src/KendoMap/index.js